import {AbstractAdminEntityService} from "./AbstractAdminEntityService";
import {HttpService} from "../http/HttpService";
import { DataSet, MetricsListResponse } from "../http/protocol";


export class MetricsService extends AbstractAdminEntityService<any,any> implements MetricsService {
    constructor(http: HttpService) {
        super("/analytics", http);
    }

    async getUniqueUsersCount(type: string, from?: string, to?: string) : Promise<DataSet> {
        if (from !== undefined && to !== undefined) {
            return this.http.get(`${this.entityPath}/users/${type}?from=${from}&to=${to}`);
        } else {
            return this.http.get(`${this.entityPath}/users/${type}`);
        }
    }

    async getSum(type:string,product?:string|null,currency?:string|null, from?:string, to?:string, role?:string) : Promise<DataSet> {
        let prod = product !== undefined ? product : null;
        let curr = currency !== undefined ? currency : null;

        if(from !== undefined && to !== undefined && prod != null) {
            return this.http.get(`${this.entityPath}/sum/${type}?product=${prod}&currency=${curr}&from=${from}&to=${to}&role=${role}`);
        } else if(from !== undefined && to !== undefined && prod === null) {
            return this.http.get(`${this.entityPath}/sum/${type}?currency=${curr}&from=${from}&to=${to}&role=${role}`);
        } else {
            return this.http.get(`${this.entityPath}/sum/${type}?currency=${curr}&role=${role}`);
        }
    }

    
    async getSumByUserId(type:string,product?:string|null,currency?:string|null, from?:string, to?:string, userId?:string|null, role?:string|null) : Promise<DataSet>{
        let prod = product !== undefined ? product : null;
        let curr = currency !== undefined ? currency : null;
        let user = userId !== undefined ? userId : null;

        if(from !== undefined && to !== undefined && prod != null) {
            return this.http.get(`${this.entityPath}/sum/${type}?product=${prod}&currency=${curr}&from=${from}&to=${to}&userId=${user}&role=${role}`);
        } else if(from !== undefined && to !== undefined && prod === null) {
            return this.http.get(`${this.entityPath}/sum/${type}?currency=${curr}&from=${from}&to=${to}&userId=${user}&role=${role}`);
        } else {
            return this.http.get(`${this.entityPath}/sum/${type}?currency=${curr}&userId=${user}&role=${role}`);
        }
    }

    
    async getEventDailySum(type:string, timeFrame: string, currency?:string|null, role?:string|null) : Promise<MetricsListResponse>{
        
        return this.http.get(`${this.entityPath}/metrics/sum/${type}?timeFrame=${timeFrame}&currency=${currency}&role=${role}`);
    
    }

    async getUserEventDailySum(type:string, timeFrame: string, currency?:string|null, role?:string|null, userId?:number|null) : Promise<MetricsListResponse>{

        return this.http.get(`${this.entityPath}/metrics/sum/${type}?timeFrame=${timeFrame}&currency=${currency}&role=${role}&userId=${userId}`);
      
    }

}